import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import gql from 'graphql-tag';
import { Query } from 'react-apollo';

import Wrap from 'components/Wrap';
import Header from 'components/Header';
import Hero from 'components/Hero';
import Alert from 'components/Alert';
import Loader from 'components/Loader';
import List from 'components/List';

const getSweepstake = gql`
  query Contest($id: ID!) {
    contests(id: $id, has_winners: true, limit: 1) {
      name
      banner
      winners
    }
  }
`;

class Winners extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <Query query={getSweepstake} variables={{ id: this.props.match.params.id }}>
        {({ loading, error, data }) => {
          if (loading) return <Loader />;
          if (error) return <Alert>Erro! {error.message}</Alert>;

          const sweepstake = data.contests[0];
          const winners = sweepstake.winners;

          return !sweepstake ? (
            <Redirect to="/" />
          ) : (
            <>
              <Wrap>
                <Header img={sweepstake.banner} />
                <Hero {...sweepstake} backButton />
              </Wrap>
              {winners.length > 0 && <List title="Vencedores" items={winners} />}
            </>
          );
        }}
      </Query>
    );
  }
}

export default Winners;
